export const CustomMenuCategoryCode = {
    DEFAULT: 'DEFAULT',
    FACILITY: 'FACILITY',
    FNB: 'FNB',
    PARKING: 'PARKING'
} as const;

export type CustomMenuCategoryCodeType = (typeof CustomMenuCategoryCode)[keyof typeof CustomMenuCategoryCode];

type MenuForCodeResolve = {
    menuCode?: string | null;
};

/**
 * Resolves category-type layout variant from menuCode.
 * - No menuCode → default category-type (carousel POI + search)
 * - menuCode === FACILITY → Facility category grid layout
 */
export const resolveCategoryMenuCode = (menu: MenuForCodeResolve): string | undefined => {
    return menu.menuCode ?? undefined;
};
